import { createReducer, on } from '@ngrx/store';
import { initialState } from './state';
import * as LocationCardActions from '../actions';
import { normalizeSection } from '../config.models';
import { foreSiteRadarSensor } from '../configs/foresite-xd/sensors/radar-sensor';
import { ForesiteXDLocationCardState } from '../configs/foresite-xd/models';
import { ForesiteXDSectionIds, ForeSiteRadarSensorFieldIds } from '../configs/foresite-xd/base-config-models';

export const foresiteXdReducer = createReducer(
    initialState as ForesiteXDLocationCardState,

    on(LocationCardActions.foresiteXdSensorChange, (state, { sensorValue }) => {
        const formState = { ...state.formState };
        const hasRadarSection = formState.config.sections.some((s) => s.id === ForesiteXDSectionIds.RadarSensor);

        if (!sensorValue) {
            if (hasRadarSection) {
                formState.config.sections = formState.config.sections.filter(
                    (s) => s.id !== ForesiteXDSectionIds.RadarSensor,
                );
            }
        } else {
            if (!hasRadarSection) {
                const radarSection = normalizeSection(foreSiteRadarSensor(state));
                formState.config.sections.push(radarSection);
            }
        }

        return { ...state, formState };
    }),

    on(LocationCardActions.foresiteXdMaxRangeChange, (state, { value }) => {
        const formState = { ...state.formState };
        const radarSection = formState.config.sections.find((s) => s.id === ForesiteXDSectionIds.RadarSensor);

        if (radarSection) {
            const warningField = radarSection.fields[ForeSiteRadarSensorFieldIds.MaxRangeWarning];
            if (warningField) {
                warningField.visible = value === 12000;
            }
        }

        return { ...state, formState };
    }),
);
